import { useState } from 'react';
import { FormsV1 } from '@frontend/api-digital-forms';
import { useTranslation } from '@frontend/i18n';
import { useAlert } from '@frontend/design-system';
import { DEFAULT_DFX_HTTP_OPTIONS } from '../constants';
import { getPDFObjectURL } from '../helpers/pdf-helpers';

export const useDownloadFormPDF = (locationId: string, submissionId: string) => {
  const { t } = useTranslation('digital-forms-experience');
  const alerts = useAlert();
  const [isDownloading, setIsDownloading] = useState(false);

  const fetchFormPdf = FormsV1.Queries.useFetchGetFormPDF();

  const downloadPdf = async () => {
    if (!locationId || !submissionId) {
      alerts.error(t('Missing location or submission information for PDF generation!'));
      return;
    }

    try {
      setIsDownloading(true);
      const res = await fetchFormPdf({
        request: { companyId: locationId, submissionId },
        httpOptions: { ...DEFAULT_DFX_HTTP_OPTIONS },
      });
      if (!res?.file) {
        alerts.error(t('Failed to generate the PDF!'));
        return;
      }

      const pdfUrl = getPDFObjectURL(res.file);

      const pdfWindow = window.open(pdfUrl, '_self');
      if (pdfWindow) {
        const interval = setInterval(() => {
          if (pdfWindow.closed) {
            // revoke the object URL to release memory
            URL.revokeObjectURL(pdfUrl);
            clearInterval(interval);
          }
        }, 500);
      }
    } catch (error) {
      alerts.error(t('Failed to generate the PDF!'));
    } finally {
      setIsDownloading(false);
    }
  };

  return {
    downloadPdf,
    isDownloading,
  };
};
